export const environment = {
	production: true,
	appCode: 'Alsace appyvisite-admin',
	appVersion: '1',
	languages: ['en', 'fr'],
	appName: 'Alsace appyvisite',
	login: {
		redirection: [''],
	},
	logout: {
		redirection: ['session', 'sign-in'],
	},
	api: {
		uri: 'https://api.alsaceav.appymax.com/v1',
		adminPath: '/admin',
	},
	images: {
		uri: 'https://s3.appymax.com/gergovie/',
	},
	plugins: {
		quickForm: {
			enabled: true,
		},
	},
};
